import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert,Modal, Table, UncontrolledTooltip } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as ur from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import FMap from 'pages/WQ/Maps/FMaps';
import { useParams } from 'react-router-dom';


    const WaterProductionDetails = () => {
        const history = useHistory();
        const {id} = useParams()
        const [modal_line, setmodal_line] = useState(false);
        const [modal_chemicals, setmodal_chemicals] = useState(false);
        const [modal_energy, setmodal_energy] = useState(false);
        const [modal_incidents, setmodal_incidents] = useState(false);
        const [modal_quality, setmodal_quality] = useState(false);

        const [isEdit, setIsEdit] = useState(false)
        const [isLoading, setIsLoading] = useState(false)

        const [status, setStatus] = useState('')
        const [dateTimePosted, setDateTimePosted] = useState('')
        const [documentNo, setDocumentNo] = useState('')
        const [postedBy, setPostedBy] = useState('')
        const [postedByName, setPostedByName] = useState('')
        const [userId, setUserId] = useState('')


        const [resultsList, setResultsList] = useState([])
        const [chemicalData, setChemicalData] = useState([])
        const [energyData, setEnergyData] = useState([])
        const [incidentData, setIncidentData] = useState([])
    
        const [isloading, setIsloading] = useState(false);
        toastr.options = TOAST_OPTIONS;

        const [paramsList, setParamsList] = useState([]);
        const [sPointsList, setSPointsList] = useState([]);
        const [stageList, setStageList] = useState(['In-Flow', 'Out-Flow'])

        const [areas, setAreas] = useState([])
        const [schemes, setSchemes] = useState([])
        const [facilities, setFacilities] = useState([])

        const [productionId, setProductionId] = useState('')
        const [facilityId, setFacilityId] = useState('')
        const [productionDate, setProductionDate] = useState([new Date()])

        const [lineId, setLineId] = useState('')
        const [stage, setStage] = useState('')
        const [pr, setPR] = useState('')
        const [cr, setCR] = useState('')
        const [vl, setVL] = useState('')

        const [chemicalsList, setChemicalsList] = useState([])
        const [chemicalId, setChemicalId] = useState('')
        const [chemicalAmount, setChemicalAmount] = useState('')
        const [dosage, setDosage] = useState('')

        const [sources, setSources] = useState(['Generator 1','Generator 2','Generator 3','Generator 4','Generator 5','Generator 6',])
        const [powerSource, setPowerSource] = useState('')
        const [r1, setR1] = useState(0)
        const [r2, setR2] = useState(0)
        const [hoursUsed, setHoursUsed] = useState(0)
        const [unitsUsed, setUnitsUsed] = useState('')
        const [otherDetails, setOtherDetails] = useState('')

        const [incidents, setIncidents] = useState(['Power supply failure', 'Shutdown' , 'Low voltage', 'High voltage'])
        const [incident, setIncident] = useState('')
        const [incidentHours, setIncidentHours] = useState(0)
        const [incidentDetails, setIncidentDetails] = useState('')

        const [points, setPoints] = useState([])
        const [pipes, setPipes] = useState([])

        const [approverId, setApproverId] = useState("")
        const [action, setAction] = useState('')
        const [comment, setComment] = useState('')

        useEffect(() => {
            if (!isNaN(parseInt(r1)) && !isNaN(parseInt(r2))) {
            const difference = Math.abs(parseInt(r1) - parseInt(r2));
            setUnitsUsed(difference.toString());
            }
        }, [r1, r2]);
        
        const handleR1Change = (event) => {
            setR1(event.target.value);
        };
        
        const handleR2Change = (event) => {
            setR2(event.target.value);
        };

        useEffect(() => {
            if (!isNaN(parseInt(pr)) && !isNaN(parseInt(cr))) {
            const difference = Math.abs(parseInt(cr) - parseInt(pr));
            setVL(difference.toString());
            }
        }, [pr, cr]);
        
        const handlePRChange = (event) => {
            setPR(event.target.value);
        };
        
        const handleCRChange = (event) => {
            setCR(event.target.value);
        };
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_line = () => {
            setmodal_line(!modal_line)
            removeBodyCss()
        }
        const tog_chemicals = () => {
            setmodal_chemicals(!modal_chemicals)
            removeBodyCss()
        }
        const tog_energy = () => {
            setmodal_energy(!modal_energy)
            removeBodyCss()
        }
        const tog_incidents = () => {
            setmodal_incidents(!modal_incidents)
            removeBodyCss()
        }
        const tog_quality = () => {
            setmodal_quality(!modal_quality)
            removeBodyCss()
        }

        const handlePreviousReadingChange = (event) => {
            const newPreviousReading = parseFloat(event.target.value);
            setPR(newPreviousReading);
            updateVolume(newPreviousReading, cr);
          };
        
          const handleCurrentReadingChange = (event) => {
            const newCurrentReading = parseFloat(event.target.value);
            setCR(newCurrentReading);
            updateVolume(pr, newCurrentReading);
          };
        
          const handleVolumeChange = (event) => {
            const newVolume = parseFloat(event.target.value);
            setVL(newVolume);
            updateReadings(pr, newVolume);
          };

          const updateVolume = (prev, current) => {
            const newVolume = current - prev;
            setVL(isNaN(newVolume) ? '' : newVolume.toFixed(0));
          };
        
          const updateReadings = (prev, vol) => {
            const newCurrentReading = prev + vol;
            setCR(isNaN(newCurrentReading) ? '' : newCurrentReading.toFixed(0));
          };

        const handleGetFacilitiesInScheme = (s)=>{
            setFacilities([])  
            setIsLoading(true)
            axios.get(ur.FACILITIES+"?scheme?"+s, Config).then((r)=>{ 
                setFacilities(r.data);
                setIsLoading(false)
            }).catch((e)=>{  
                console.log(e); 
                setIsLoading(false)
            });
        }

        const handleSaveVolumes = () =>{
            if(stage.length < 1){
                toastr.error('Select stage')
            }else{
                const data = {
                    id: isEdit ? lineId : '',
                    stage: stage,
                    pId:be.decryptId(id),
                    pr:pr,
                    cr:cr,
                    vl:vl,
                    action: isEdit?'edit':'add'
                }
                setIsloading(true)
                axios.post(ur.PRODUCTIONSTAGELINE, JSON.stringify(data), Config).then((r)=>{
                    if(r.data.status == "1"){
                        toastr.success(r.data.message)
                        tog_line()
                        setStage('')
                        setPR('')
                        setCR('')
                        setVL(0)
                        fetchData()
                    }else{
                        toastr.error(r.data.message)
                    }
                    setIsloading(false)
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
        }
        const handleViewVolume = (key) =>{
            setIsEdit(true)
            setLineId(resultsList[key].id)
            setStage(resultsList[key].stage)
            setPR(resultsList[key].pr)
            setCR(resultsList[key].cr)
            setVL(resultsList[key].vl)
            tog_line()
        }

        const handleRemoveVolume = (key) =>{
            const data = {
                id: resultsList[key].id,
                productionId: productionId,
                stage: resultsList[key].stage,
                pr: "",
                cr:"",
                vl:"",
                action: 'delete'
            }
            setIsloading(true)
            axios.post(ur.PRODUCTIONSTAGELINE, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })
        }
        const handleViewChemicals = (key) =>{
            setIsEdit(true)
            setLineId(chemicalData[key].id)
            setChemicalId(chemicalData[key].chemicalId)
            setChemicalAmount(chemicalData[key].amount)
            setDosage(chemicalData[key].dosage)
            tog_chemicals()
        }
        const handleAddChemical = () =>{
            if(chemicalId == ""){
                toastr.error('Select chemical')
            }else if(chemicalAmount.length < 1){
                toastr.error('Enter quantities used')
            }else{
                const data = {
                    id: isEdit?lineId:'',
                    pId: be.decryptId(id),
                    chemicalId: chemicalId, 
                    quantity: chemicalAmount, 
                    dosage: dosage,
                    action: isEdit?'edit':'add'
                }
                setIsloading(true)
                axios.post(ur.PRODUCTIONCHEMICALS, JSON.stringify(data), Config).then((r)=>{
                    if(r.data.status == '1'){
                        toastr.success(r.data.message)
                        tog_chemicals()
                        setChemicalId('')
                        setChemicalAmount('')
                        setDosage('')
                        fetchData()
                    }else{
                        toastr.error(r.data.message)
                    }
                    setIsloading(false)
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
        }
        const handleRemoveChemical = (key) =>{
            const data = {
                id: chemicalData[key].id,
                pId: be.decryptId(id),
                chemicalId: "", 
                quantity: "", 
                dosage: "",
                action: 'delete'
            }
            setIsloading(true)
            axios.post(ur.PRODUCTIONCHEMICALS, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleAddEnergy = () =>{
            if(powerSource == ''){
                toastr.error('Select power source')
            }else{
                const data = {
                    id:isEdit?lineId:'',
                    pId:be.decryptId(id),
                    source: powerSource,
                    r1:r1,
                    r2:r2,
                    units: unitsUsed,
                    otherDetails: otherDetails,
                    action:isEdit?'edit':'add'
                }
                setIsloading(true)
                axios.post(ur.PRODUCTIONENERGY, JSON.stringify(data), Config).then((r)=>{
                    if(r.data.status == '1'){
                        toastr.success(r.data.message)
                        tog_energy()
                        setPowerSource('')
                        setR1('')
                        setR2('')
                        setUnitsUsed('')
                        setOtherDetails('')
                        fetchData()
                    }else{
                        toastr.error(r.data.message)
                    }
                    setIsloading(false)
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
        }
        const handleViewEnergy = (key) =>{
            setIsEdit(true)
            setLineId(energyData[key].id)
            setPowerSource(energyData[key].source)
            tog_energy()
            setR1(energyData[key].r1)
            setR2(energyData[key].r2)
            setUnitsUsed(energyData[key].units)
            setHoursUsed(energyData[key].hours)
            setOtherDetails(energyData[key].details)
        }
        const handleRemoveEnergy = (key)=>{
            const data = {
                id:lineId,
                pId:be.decryptId(id),
                source: "",
                r1:"",
                r2:"",
                units: "",
                otherDetails: "",
                action:'delete'
            }
            setIsloading(true)
            axios.post(ur.PRODUCTIONENERGY, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleSaveIncident = () =>{
            if(incident == ''){
                toastr.error('Select incident')
            }else if(incidentHours.length < 1){
                toastr.error('Enter hours ')
            }else{
                const data = {
                    incident: incident,
                    incidentHours: incidentHours,
                    incidentDetails: incidentDetails
                }
                setIncidentData(state=>[...state, data])
                tog_incidents()
                setIncident('')
                setIncidentHours('')
                setIncidentDetails('')
            }
        }
        const handleRemoveIncident = (key) =>{
            const newItems = [...incidentData];
            newItems.splice(key, 1);
            setIncidentData(newItems);
        }
        const handleUpdateProduction = () =>{
            if(facilityId == ""){
                toastr.error('Select facility')
            }else{
                const data = {
                    id: be.decryptId(id),
                    productionDate: formatDate(productionDate),
                    facilityId  : facilityId,
                    postedBy    : postedBy,
                    volumes     : resultsList,
                    chemicals   : chemicalData,
                    energy      : energyData,
                    incidents   : incidentData,
                    action      : 'edit'
                }
                setIsloading(true)
                axios.post(ur.PRODUCTION, JSON.stringify(data), Config).then((r)=>{
                    if(r.data.status == 1){
                        toastr.success(r.data.message)
                        fetchData()
                    }else{
                        console.log(r)
                    }
                    setIsloading(false)
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
            }
        }
        const handleApprovalRequest = () =>{
            setIsloading(true)
            const data = {
                action  : 'request', 
                entity  : 'Production',
                no      : documentNo, 
                id      : be.decryptId(id), 
                userId  : userId
            }
            axios.post(ur.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        
        const handleCancelApproval = () =>{
            setIsloading(true)
            const data = {
                action  : 'cancel', 
                entity  : 'Production',
                no      : documentNo,
                id      : productionId, 
                userId  : userId
            }
            axios.post(ur.APPROVAL, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleApproval = () =>{
            if(action == ""){
                toastr.error('You can select Approve or Reject')
            }else{
                if((action == "Reject") && (comment.trim().length < 4)){
                    toastr.error("Please state reason for rejecting")
                }else{
                    const data = {
                        action  : action, 
                        entity  : 'Production',
                        no      : documentNo, 
                        id      : be.decryptId(id), 
                        userId  : userId, 
                        comment : comment
                    }
                    setIsloading(true)
                    axios.post(ur.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                        if(r.data.status == 1){
                            toastr.success(r.data.message)
                            history.push('/Notifications')
                        }else{
                            toastr.error(r.data.message)
                        }
                        setIsloading(false)
                    }).catch((e)=>{
                        console.log(e)
                        setIsloading(false)
                    })
                }
            }
        }
        const handleDeleteProduction = () =>{
           
                const data = {
                    id              : be.decryptId(id),
                    productionDate  : formatDate(productionDate),
                    facilityId      : facilityId,
                    postedBy        : postedBy,
                    volumes         : resultsList,
                    chemicals       : chemicalData,
                    energy          : energyData,
                    incidents       : incidentData,
                    action          : 'delete'
                }
                setIsloading(true)
                axios.post(ur.PRODUCTION, JSON.stringify(data), Config).then((r)=>{
                    if(r.data.status == 1){
                        toastr.success(r.data.message)
                        history.push(`/water-production`) 
                    }else{
                        console.log(r)
                    }
                    setIsloading(false)
                }).catch((e)=>{
                    console.log(e)
                    setIsloading(false)
                })
        }
        

        const fetchData = () => {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id)
            axios.get(ur.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
            axios.get(ur.SCHEME, Config).then((r)=>{ setSchemes(r.data); }).catch((e)=>{  console.log(e); });
            axios.get(ur.SAMPLINGPOINTS, Config).then((r)=>{ setSPointsList(r.data);  }).catch((e)=>{  console.log(e); });
            axios.get(ur.PARAMETERS, Config).then((r)=>{ setParamsList(r.data);  }).catch((e)=>{  console.log(e); });
            axios.get(ur.CHEMICALS, Config).then((r)=>{ setChemicalsList(r.data); }).catch((e)=>{ console.log(e)})
            axios.get(ur.FACILITIES, Config).then((r)=>{ 
                setFacilities(r.data);
            }).catch((e)=>{  
                console.log(e); 
            });
            setIsloading(true)
            axios.post(ur.PRODUCTIONFILTER, JSON.stringify({id:be.decryptId(id)}), Config).then((r)=>{
                setDocumentNo(r.data[0].documentNo)
                setFacilityId(r.data[0].facilityId)
                axios.post(ur.GEOCOORDINATES, JSON.stringify({filter: r.data[0].facilityId}), Config).then((rr)=>{ 
                    if(rr.data.length > 0){
                      setPoints(rr.data); 
                    }
                }).catch((ee)=>{ console.log(ee)})
                setStatus(r.data[0].status)
                setPostedByName(r.data[0].user)
                setPostedBy(r.data[0].userId)
                setDateTimePosted(r.data[0].postedOn)
                setProductionDate(new Date(r.data[0].date))
                setResultsList(r.data[0].volumes)
                setChemicalData(r.data[0].chemicals)
                setEnergyData(r.data[0].energy)
                setIncidentData(r.data[0].incidents)
                setApproverId(r.data[0].approverId)
                //setApproverId("1")
                setIsloading(false)
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        const handleGetCoordinates = (f) =>{
            axios.post(ur.GEOCOORDINATES, JSON.stringify({filter: f}), Config).then((rr)=>{ 
                if(rr.data.length > 0){
                  setPoints(rr.data); 
                }
            }).catch((ee)=>{ console.log(ee)})
        }
        useEffect(() => {
         fetchData();
        },[]);

        const handleGetSchemesInArea = (a) =>{
            setIsLoading(true)
            axios.get(`${ur.SCHEME}?area?${a}`, Config).then((r)=>{
              setSchemes(r.data)   
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }
        
        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Production details | {ur.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        
                        <div>
                        <Row>
                        <Col xl={8}>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Production Details</h5>
                            <CardBody>
                                    <Row className='mt-4 mb-4'>
                                   {/*} <Col md={4}>
                                        <div className="mb-3">
                                        <label>Area</label>
                                        <select className="form-select" onChange={(e)=>{handleGetSchemesInArea(e.target.value);}}>
                                        <option value=""></option>
                                        {areas.map((a,k)=>(
                                                <option key={k} value={a.id}>{a.name}</option>
                                            )
                                        )}
                                            </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Scheme</label>
                                        <select className="form-select" onChange={(e)=>handleGetFacilitiesInScheme(e.target.value)}>
                                        <option value=""></option>
                                        {schemes.map((s,k)=>(
                                                <option key={k} value={s.id}>{s.scheme}</option>
                                            )
                                        )}
                                            </select>
                                        
                                        </div>
                                    </Col> */}
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Document No</label>
                                                <input  type='text' className="form-control" value={documentNo} onChange={(e)=>setDocumentNo(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Facility</label>
                                        <select className="form-select" value={facilityId} onChange={(e)=>{ setFacilityId(e.target.value); handleGetCoordinates(e.target.value)}} >
                                        <option value=""></option>
                                            {facilities.map((f,k)=>(
                                                    <option key={k} value={f.id}>{f.facility}</option>
                                                )
                                            )}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Production date</label>
                                                <Flatpickr
                                                    className="form-control"
                                                    options={{
                                                        mode: "single",
                                                        dateFormat: "Y-m-d",
                                                        enableTime: false
                                                    }}
                                                    disabled={((status == 'Open') && (postedBy == userId))?false:true}
                                                    value={productionDate}
                                                    onChange={(date)=>setProductionDate(date)}
                                                    />
                                                
                                        </div>
                                    </Col>
                            
                                    
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Status</label>
                                                <input  type='text' className="form-control" value={status} onChange={(e)=>setStatus(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Date and time Posted</label>
                                                <input  type='text' className="form-control" value={dateTimePosted} onChange={(e)=>setDateTimePosted(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Posted By</label>
                                                <input  type='text' className="form-control" value={postedByName} onChange={(e)=>setPostedByName(e.target.value)} disabled={true}/>
                                                
                                        </div>
                                    </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            

                            <Modal isOpen={modal_line} toggle={() => { tog_line(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Volumes`:`Add Volumes` }</h5>
                                    <button type="button"  onClick={() => { setmodal_line(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row>
                                   <Col lg={6} className="mb-3">
                                        <div className="mb-3">
                                        <label>Stage</label>
                                        <select className="form-select" value={stage} onChange={(e)=>{setStage(e.target.value);}}>
                                            <option value=""></option>
                                            {(stageList || []).map((s, k) => (
                                                <option value={s} key={k} >{s}</option>
                                            ))}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Previous meter readings</label>
                                            <input  type='number' className="form-control" value={pr} onChange={handlePRChange} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Current meter readings</label>
                                            <input  type='number' className="form-control" value={cr} onChange={handleCRChange} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Volumes (cu.m)</label>
                                            <input  type='number' className="form-control" value={vl} onChange={(e)=>setVL(e.target.value)} />    
                                        </div>
                                    </Col>
                                    
                                   </Row>
                                  </div>
                                  <div className="modal-footer justify-content-end">
                                  <button type="button" className="btn btn-danger me-2" onClick={()=>tog_line()} >Cancel</button> 
                                    {(isLoading ? 
                                          (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={handleSaveVolumes}>Save volumes...</button> ))
                                    }</div>
                                </Modal>

                                <Modal isOpen={modal_chemicals} toggle={() => { tog_chemicals(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Chemicals Used`:`Add Chemicals Used` }</h5>
                                    <button type="button"  onClick={() => { setmodal_chemicals(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row>
                                   <Col lg={12}>
                                        <div className="mb-3">
                                        <label>Chemical</label>
                                        <select className="form-select" value={chemicalId} onChange={(e)=>{setChemicalId(e.target.value);}}>
                                            <option value=""></option>
                                            {(chemicalsList || []).map((c, k) => (
                                                <option value={c.id} key={k} >{c.chemical}</option>
                                            ))}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Quantity (kgs)</label>
                                            <input  type='number' className="form-control" value={chemicalAmount} onChange={(e)=>setChemicalAmount(e.target.value)} />    
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Dosage (mg/L)</label>
                                            <input  type='number' className="form-control" value={dosage} onChange={(e)=>setDosage(e.target.value)} />    
                                        </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer justify-content-end">
                                  <button type="button" className="btn btn-danger me-2" onClick={()=>tog_chemicals()} >Cancel</button> 
                                    {(isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={handleAddChemical}>Save chemicals...</button> ))
                                    }</div>
                                </Modal>

                                <Modal isOpen={modal_energy} toggle={() => { tog_energy(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Energy Used`:`Add Energy Used` }</h5>
                                    <button type="button"  onClick={() => { setmodal_energy(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row>
                                   <Col lg={12}>
                                        <div className="mb-3">
                                        <label>Source</label>
                                        <select className="form-select" value={powerSource} onChange={(e)=>setPowerSource(e.target.value)} >
                                            <option value=""></option>
                                            {(sources || []).map((c, k) => (
                                                <option value={c} key={k} >{c}</option>
                                            ))}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>R1</label>
                                            <input  type='number' className="form-control" value={r1} onChange={handleR1Change}/>    
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>R2</label>
                                            <input  type='number' className="form-control" value={r2} onChange={handleR2Change}/>    
                                        </div>
                                    </Col>
                                 
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Units Used</label>
                                            <input  type='number' className="form-control" value={unitsUsed} onChange={(e)=>setUnitsUsed(e.target.value)}/>    
                                        </div>
                                    </Col>
                                
                                    
                                   </Row>
                                  </div>
                                  <div className="modal-footer justify-content-end">
                                  <button type="button" className="btn btn-danger me-2" onClick={()=>tog_energy()} >Cancel</button> 
                                    {(isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={handleAddEnergy}>Save energy data...</button> ))
                                    }</div>
                                </Modal>

                                <Modal isOpen={modal_incidents} toggle={() => { tog_incidents(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Incident`:`Report Incident` }</h5>
                                    <button type="button"  onClick={() => { setmodal_incidents(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row>
                                   <Col lg={12}>
                                        <div className="mb-3">
                                        <label>Incident</label>
                                        <select className="form-select" value={incident} onChange={(e)=>setIncident(e.target.value)} >
                                            <option value=""></option>
                                            {(incidents || []).map((c, k) => (
                                                <option value={c} key={k} >{c}</option>
                                            ))}
                                        </select>
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Incident Duration (hours)</label>
                                            <input  type='number' className="form-control" value={incidentHours} onChange={(e)=>setIncidentHours(e.target.value)}/>    
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Other details</label>
                                            <input  type='text' className="form-control" value={incidentDetails} onChange={(e)=>setIncidentDetails(e.target.value)} />    
                                        </div>
                                    </Col>
                                    
                                   </Row>
                                  </div>
                                  <div className="modal-footer justify-content-end">
                                  <button type="button" className="btn btn-danger me-2" onClick={()=>tog_incidents()} >Cancel</button> 
                                    {(isLoading ? 
                                            (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                        : ( <button type="button" className="btn btn-success" onClick={handleSaveIncident}>Save Incident...</button> ))
                                    }</div>
                                </Modal>
                                
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Volumes</h5>
                                <CardBody>
                                
                                <div>
                                {(resultsList.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Stage</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Previous readings</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Current readings</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Volumes (cu.m)</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {resultsList.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td>{a.stage}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.pr}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.cr}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.volumes}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                                <div>
                                                                    {((status == 'Open') && (postedBy == userId)) && (
                                                                        <>
                                                                        <Link
                                                                            to="#"
                                                                            className="text-success"
                                                                            onClick={() => handleViewVolume(k)}
                                                                            >
                                                                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                            <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
                                                                        </Link>
                                                                       <Link
                                                                            to="#"
                                                                            className="text-danger"
                                                                            onClick={()=>handleRemoveVolume(k)}
                                                                            >
                                                                            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                                Delete
                                                                            </UncontrolledTooltip>
                                                                        </Link>
                                                                        </>
                                                                    )}
                                                                    
                                                                    </div>

                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-5" />
                                                    </div>
                                                    <div>
                                                    <h5>No data yet</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                 
                     
                                        </div>
                                    
                                        {((status == 'Open') && (postedBy == userId)) && 
                                            <Row className=' mb-4 mt-4 justify-content-center'>
                                                    <Col md={4}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="success"
                                                                className="btn btn-rounded"
                                                                onClick={() => { tog_line(); setPR(''), setCR(''); setVL(''); setIsEdit(false); }}
                                                                >
                                                                Add volumes
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                   
                                        
                                                </Row>
                                        }
                                            </CardBody>
                                        </Card>

                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Chemicals</h5>
                                <CardBody>
                                <div>
                                {(chemicalData.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Name</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Quantity (kgs)</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Dosage (mg/L)</th>
                                                            <th></th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {chemicalData.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{k+1}</td>
                                                                <td> {a.chemicalName}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.amount}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.dosage}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                                <div>
                                                                {((status == 'Open') && (postedBy == userId)) && (
                                                                        <>
                                                                        <Link
                                                                            to="#"
                                                                            className="text-success"
                                                                            onClick={() => handleViewChemicals(k)}
                                                                            >
                                                                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                            <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
                                                                        </Link>
                                                                       <Link
                                                                            to="#"
                                                                            className="text-danger"
                                                                            onClick={()=>handleRemoveChemical(k)}
                                                                            >
                                                                            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                                Delete
                                                                            </UncontrolledTooltip>
                                                                        </Link>
                                                                        </>
                                                                    )}
                                                                    </div>
                                                                </td>
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-5" />
                                                    </div>
                                                    <div>
                                                    <h5>No data yet</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                 
                     
                                        </div>
                                    
                                        {((status == 'Open') && (postedBy == userId)) && (
                                             <Row className=' mb-4 mt-4 justify-content-center'>
                                                    <Col md={4}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="success"
                                                                className="btn btn-rounded"
                                                                onClick={() => { tog_chemicals(); setChemicalAmount(0); setChemicalId(''); setDosage(''); setIsEdit(false) }}
                                                                >
                                                                Add chemicals used
                                                            </Button>
                                                        </div>
                                                    </Col> 
                                                </Row>
                                        )}
                                            </CardBody>
                                        </Card>
                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Energy</h5>
                                <CardBody>
                                <div>
                                {(energyData.length > 0) ? (
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-sm mb-4">
                                                    <thead>
                                                    <tr>
                                                            <th>Power source</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>R1</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>R2</th>
                                                            <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Units used</th>
                                                            
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                      	                {energyData.map((a,k)=>(
                                                            <tr key={k}>
                                                                <td>{a.source}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.r1}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.r2}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.units}</td>
                                                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                                                <div>
                                                                {((status == 'Open') && (postedBy == userId)) && (
                                                                        <>
                                                                        <Link
                                                                            to="#"
                                                                            className="text-success"
                                                                            onClick={() => handleViewEnergy(k)}
                                                                            >
                                                                            <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                            <UncontrolledTooltip placement="top" target="edittooltip">Edit</UncontrolledTooltip>
                                                                        </Link>
                                                                       <Link
                                                                            to="#"
                                                                            className="text-danger"
                                                                            onClick={()=>handleRemoveEnergy(k)}
                                                                            >
                                                                            <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                            <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                                Delete
                                                                            </UncontrolledTooltip>
                                                                        </Link>
                                                                        </>
                                                                    )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-danger display-5" />
                                                    </div>
                                                    <div>
                                                    <h5>No  data</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )}
                                            </div>
                                            {((status == 'Open') && (postedBy == userId)) && (
                                            <Row className=' mb-4 mt-4 justify-content-center'>
                                                    <Col md={4}>
                                                        <div className="d-grid gap-2">
                                                            <Button
                                                                color="success"
                                                                className="btn btn-rounded"
                                                                onClick={() => { tog_energy(); setIsEdit(false); setPowerSource(''), setR1(''), setR2(''), setUnitsUsed(''); setHoursUsed('') }}
                                                                >
                                                                Add energy data
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}
                                </CardBody>
                            </Card>

                            {(status == 'Pending Approval') && (userId == approverId) && (
                                        <Card>
                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Approve/Reject (You are the approver)</h5>
                                            <CardBody>
                                                <Row className="mb-2 mt-3 justify-content-center">
                                                    <Col md={10} className='mb-2'>
                                                        <div className="mb-3">
                                                            <label>Action</label>
                                                            <select className="form-select" value={action} onChange={(e)=>setAction(e.target.value)}>
                                                                <option value=""></option>
                                                                <option value="Approve">Approve</option>
                                                                <option value="Reject">Reject</option>
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={10} className='mb-2'>
                                                        <div className="mb-3">
                                                            <label>Comment</label>
                                                            <textarea className="form-control" value={comment} onChange={(e)=>setComment(e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col md={6} className='mb-3'>
                                                        <div className="d-grid gap-2">
                                                            <Button color="primary" className="btn" onClick={handleApproval}>
                                                                Submit response...
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                      )} 

                           
                            {(status == 'Open') && (userId == postedBy) && (
                                            <Row className=' mb-4 mt-4 justify-content-center'>
                                                <Col md={4}>
                                                    <div className="d-grid gap-2">
                                                        <Button
                                                            color="warning"
                                                            className="btn btn-rounded"
                                                            onClick={() => { handleApprovalRequest(); }}
                                                            >
                                                            Send for approval
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="d-grid gap-2">
                                                        <Button
                                                            color="primary"
                                                            className="btn btn-rounded"
                                                            onClick={() => { handleUpdateProduction(); }}
                                                            >
                                                            Update header
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="d-grid gap-2">
                                                        <Button
                                                            color="danger"
                                                            className="btn btn-rounded"
                                                            onClick={() => { handleDeleteProduction(); }}
                                                            >
                                                            Delete
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                  
                                        {(status == 'Pending Approval') && (userId == postedBy) &&  (
                                            <Row className=' mb-4 mt-4 justify-content-center'>
                                                <Col md={6}>
                                                    <div className="d-grid gap-2">
                                                        <Button
                                                            color="warning"
                                                            className="btn btn-rounded"
                                                            onClick={() => { handleCancelApproval(); }}
                                                            >
                                                            Cancel Approval request
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}

                                        
                    
                        </Col>
        
                            <Col lg={4}>
                          <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">LOCATION</h5>
                                                         
                              <FMap points={points} pipes={pipes}/>
                            
                          </Card>
                        </Col>
                        </Row>
                       
                        </div>


                    </Container>
                    
                       
                    
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default WaterProductionDetails;